import getAllTeams from "./getAllTeams";
import getComments from "./getComments";
import getCoach from "./getCoach";
import getLineup from "./getLineup";
import getMatchById from "./getMatchById";
import getPlayer from "./getPlayer";
import getPlayersByMatch from "./getPlayersByMatch";
import getSummary from "./getSummary";
import getTeam from "./getTeam";
import getPhases from "./getPhases";
import getAllMatches from "./getAllMatches";
import getMatchesByRound from "./getMatchesByRound";
import getTeamsByGroup from "./getTeamsByGroup";

export default {
    getAllTeams, // Se usa en NodoMundial/Equipos
    getComments, // Se utiliza en VCardPartido/Comentarios
    getCoach, // Se usa en VCardDirectorTécnico => FALTAN DATOS DE LA API
    getLineup, // Se usa en VCardPartido/Alineación
    getMatchById, // Se usa en VCardPartido
    getPlayer, // Se usa en VCardJugador => FALTAN DATOS DE LA API
    getPlayersByMatch, // Se usa en VCardPartido/Jugadores
    getSummary, // Se usa en VCardPartido/Resumen
    getTeam, // Se usa en VCardEquipo => FALTAN DATOS DE LA API
    getPhases, // Se usa en NodoMundial
    getAllMatches, // Se usa en NodoMundial/Calendario
    getMatchesByRound, // Se usa en NodoMundial/Partidos
    getTeamsByGroup // Se usa en NodoMundial/Grupos

}
















// WEBPACK FOOTER //
// ./src/mundial/requests/api/index.ts